import React, { useState, useEffect } from 'react';
import { Code, FileDown } from 'lucide-react';
import CvFile from '../../assets/files/Hamza Ekhwan - CV - 2026.pdf';
import './Hero.css';

const Hero = () => {
    const [currentText, setCurrentText] = useState('');
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [showCursor, setShowCursor] = useState(true);

    const texts = [
        "Backend Developer",
        "Django Expert",
        "Python Specialist",
        "API Architect",
        "Database Designer"
    ];

    useEffect(() => {
        const speed = isDeleting ? 50 : 100;
        const currentFullText = texts[currentIndex];

        const timeout = setTimeout(() => {
            if (!isDeleting && currentText === currentFullText) {
                setTimeout(() => setIsDeleting(true), 1000);
            } else if (isDeleting && currentText === '') {
                setIsDeleting(false);
                setCurrentIndex((prev) => (prev + 1) % texts.length);
            } else {
                setCurrentText(prev =>
                    isDeleting
                        ? prev.substring(0, prev.length - 1)
                        : currentFullText.substring(0, prev.length + 1)
                );
            }
        }, speed);

        return () => clearTimeout(timeout);
    }, [currentText, isDeleting, currentIndex]);

    useEffect(() => {
        const cursorInterval = setInterval(() => {
            setShowCursor(prev => !prev);
        }, 500);

        return () => clearInterval(cursorInterval);
    }, []);

    return (
        <section className="hero">
            <div className="floating-shapes">
                <div className="shape"></div>
                <div className="shape"></div>
                <div className="shape"></div>
            </div>

            <div className="code-rain">
                {[...Array(10)].map((_, i) => (
                    <div
                        key={i}
                        className="code-line"
                        style={{
                            left: `${Math.random() * 100}%`,
                            animationDelay: `${Math.random() * 15}s`,
                            animationDuration: `${10 + Math.random() * 10}s`
                        }}
                    >
                        {['def', 'class', 'import', 'from', 'django', 'models', 'views', 'urls'][Math.floor(Math.random() * 8)]}
                    </div>
                ))}
            </div>

            <div className="container">
                <div className="hero-content">
                    <h1 className="hero-title">Hamza Ekhwan</h1>
                    <div className="typewriter-text">
                        {currentText}
                        <span className="cursor" style={{ opacity: showCursor ? 1 : 0 }}>|</span>
                    </div>
                    <p className="hero-description">
                        Passionate backend developer specializing in Django and Python. I build powerful APIs,
                        design efficient database architectures, and create scalable web applications that drive business
                        success.
                    </p>
                    <div className="hero-buttons">
                        <a href="mailto:hamzaekhwan2000@gmail.com" className="hero-cta" target="_blank" rel="noopener noreferrer">
                            <Code size={20} />
                            Hire me
                        </a>
                        <a href={CvFile} className="hero-cta" download>
                            <FileDown size={20} />
                            Resume
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
